import { useEffect, useMemo, useState } from "react";
import StrKatCreate from "./StreckenkategorieCreate";
import StreckenkatUpdate from "./StreckenkatUpdate";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from "../Tabellen/DatenLaden";
import { strKatHeader } from "../Tabellen/ConstTabKopf/StreckenkatKopf";
import StammdatenExport from "../Stammdaten/StammdatenExport";

export default function StreckenkatLaden({ instance, setTable, goBack }) {
    const [data, setData] = useState();
    const [columns, setColumns] = useState();

    useEffect(() => {
        instance.getStreckenkategorieStreckenkategorieGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setData(data);
                setColumns(strKatHeader);
            }
        });
    }, [instance])

    const reloadData = () => {
        setData();
        let loading = new Promise((result) => {
            instance.getStreckenkategorieStreckenkategorieGet((error, data) => {
                if (error) {
                    console.log(error);
                } else {
                    result(data);
                }
            });
        })
        loading.then(d => setData(d));
    }

    const prepData = useMemo(() => data, [data]);
    const additionalColumn =
    {
        id: "update",
        Header: "",
        keyword: "info",
        Cell: ({ row }) => (
            <div>
                <StreckenkatUpdate rowEntry={row} reloadData={reloadData} instance={instance} />
            </div>
        )
    }

    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            Streckenkategorie: it.kategorie,
            Bemerkung: it.bemerkung
        }))
    }

    return (
        <div>
            <StrKatCreate strKatInstance={instance} reloadData={reloadData} />
            {data && columns
                ? <div>
                    <GeneralTable data={prepData} columns={columns} hiddenColumns={['id']} additionalColumns={[additionalColumn]} />
                    <StammdatenExport csvedData={csvIt(prepData)} csvHeader={['Streckenkategorie', 'Bemerkung']} csvFilename={"sd_strkat"} />
                </div>
                : <DatenLaden />}
        </div>
    );

}